const campusGroupAdmins = {
  all_campus_group_admins: '🏫 All campus group administrators',
  create: 'Create New Campus Group Administrator',
  firstname: 'First Name',
  lastname: 'Last Name',
  lastname2nd: 'Second Last Name',
  email: 'Email',
  dni: 'DNI',
  birth_date: 'Birth Date',
  campus_group: 'Campus Group',
  general_information: 'General Information',
  select_campus_group: 'Select Campus Group',
  search_by_name: 'Search by name',
};

export default campusGroupAdmins;
